import { Component } from '@angular/core';
import { IHeaderParams } from 'ag-grid/main';
import { IHeaderAngularComp } from 'ag-grid-angular/main';
import { SearchableEntityDataEditorService } from '../../../../../services/searchable-entity/searchable-entity-data-editor.service';
import { GridViewKeyEventHandlerService } from '../../../../../services/grid-view-key-event-handler.service';

@Component({
  templateUrl: './basic-cell-header.component.html',
  styleUrls: ['./basic-cell-header.component.css']
})
export class BasicCellHeaderComponent implements IHeaderAngularComp {

  public params: any;
  public templateId: number = 0;
  public text: string = '';
  public dataEditor: SearchableEntityDataEditorService;
  public keyEventHandler: GridViewKeyEventHandlerService;
  public showTypeAhead: boolean;
  public filterdFromTypeAheadSuggestion: boolean = false;

  public agInit(params: IHeaderParams): void {
    this.params = params;


    if (this.params.column.colId === 'isSelected') {
      this.templateId = 1;
    } else {
      this.templateId = 0;
    }
    const filterModel = this.params.context.componentParent.filterModel;
    this.keyEventHandler = this.params.context.componentParent.keyEventHandler;
    this.dataEditor = this.params.context.componentParent.tableEditor;
    if (filterModel && filterModel[this.params.column.colId]) {
      this.text = filterModel[this.params.column.colId];
    }
    this.showTypeAhead = this.params.context.componentParent
      .tableConfig.showTypeAheadInHeader;
  }

  public onFilterFocus(colIndex?: number) {
    this.text = '';
    // if (colIndex) {
    //   if (colIndex !== (this.params.context
    //       .componentParent.unpinnedColumnsList.length - 1)) {
    //     this.params.api.ensureColumnVisible(this.params
    //       .context.componentParent.unpinnedColumnsList[colIndex + 1]);
    //   }
    // } else {
    this.params.api.ensureColumnVisible(this.params.column.colId);
    // }
  }

  public onFilterTab() {
    // const colIndex: number
    //   = this.params.context.componentParent.unpinnedColumnsList
    //       .findIndex((colId: string) => {
    //         return (colId === this.params.column.colId);
    //       });
    // this.onFilterFocus(colIndex);
    return false;
  }

  public isFilterActive() {
    return true;
  }

  public doesFilterPass(params) {
    // This is a server side filter. We do not need any filtering by the ag grid filtering framework
    return true;
  }

  public onChange(): void {
    const searchedValue = [];

    if (this.params.column.colDef.cellRendererParams.cellMetaData.type === 'DATE') {
      // if (this.text) {
      //   this.text = this.dateConfigService.getFormattedDisplayDate(this.text);
      // } else {
      //   this.text = '';
      // }
    } else if (this.params.column.colDef.cellRendererParams.cellMetaData.type === 'DROPDOWN' ||
             this.params.column.colDef.cellRendererParams.cellMetaData.type === 'EDITABLEDROPDOWN') {
      if (this.text) {
        /*All keys whose values correspond to the user entered values
        will be pushed to an array inorder to form search criteria */
        this.params.column.colDef.cellRendererParams.cellMetaData.values
          .map((keyValueObject: any) => {
            const pattern: any = new RegExp('^' + this.text, 'i');
            if (pattern.test(keyValueObject.value)) {
              searchedValue.push(keyValueObject.key);
            }
          });
      } else {
        this.text = '';
      }
    }
    if (searchedValue.length > 0) {
      this.params.context.componentParent
        .fetchSearchResults(this.params.column.colDef.colId, searchedValue,
          this.params.column.colDef.cellRendererParams.cellMetaData.type);
    } else {
      this.params.context.componentParent.fetchSearchResults(this.params.column.colDef.colId, this.text,
        this.params.column.colDef.cellRendererParams.cellMetaData.type);
    }
  }

  public setModel(model: any): void {
    if (model) {
      this.text = model.filter;
    }
  }

  public getModel(): any {
    return { filter: this.text };
  }

  public handleSuggestionSelected(event: any) {
    this.dataEditor.getAutoFilter(event.propertyName, event.selectedValue,
      this.params.context.componentParent.searchService,
      this.params.column.colDef.cellRendererParams.cellMetaData.type);
      this.filterdFromTypeAheadSuggestion = false;
  }

  public onValueChange(event: any) {
    if (event.keyCode === 13) {
      if (!this.filterdFromTypeAheadSuggestion) {
        this.params.context.componentParent.fetchSearchResults(this.params.column.colDef.colId,
          event.target.value, this.params.column.colDef.cellRendererParams.cellMetaData.type);
      } else {
        this.filterdFromTypeAheadSuggestion = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/results/result-data-table/renderers/basic-cell-header/basic-cell-header.component.ts